import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import { Accordion, Card, Image } from 'react-bootstrap';
import './HomeContents.css';

const EmergencyAssist = () => {
    const cover = useSelector(state => state.profile.selectedPersonalCover)

    return (
        <div id="HomeContent">
            <div className="container">
                <p className="additional-cover-header mt-3">Additional cover</p>
                <div className="row">
                    <div className="col-3">
                        <div className="home-assist"></div>
                    </div>

                    <div className="col-6">
                        <p className="additional-cover-sub-header">Home assist (included)</p>
                    </div>

                    <div className="col-3">
                        <label className="switch float-right">
                            <input type="checkbox" checked />
                            <span className="slider round"></span>
                        </label>
                    </div>

                </div>
                <hr />
                <div className="row">
                    <div className="col-3">
                        <Image className="img-fluid" src="./images/HomeContents/transport-of-contents.png" alt="Transport Of Contents" />
                    </div>

                    <div className="col-6">
                        <p className="additional-cover-sub-header">Transport of contents (included)</p>
                    </div>

                    <div className="col-3">
                        <label className="switch float-right">
                            <input type="checkbox" checked />
                            <span className="slider round"></span>
                        </label>
                    </div>

                </div>
                {cover !== undefined && cover.riskItems !== undefined &&
                    <Accordion className="mt-5">
                        <Card className="mb-5">
                            <Accordion.Toggle as={Card.Header} eventKey="0">
                                Insurance history
                           </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <p>Previous insurance duration</p>
                                    <p className="additional-cover-sub-header">{cover.riskItems[0].insuranceDuration}</p>
                                    <hr />
                                    <p>Last home contents claim</p>
                                    <p className="additional-cover-sub-header">{cover.riskItems[0].lastStolenClaim}</p>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyAssist);